import {
  Component,
  OnInit
} from "@angular/core";
import { DatePipe } from '@angular/common';
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";

import { CaTransService } from "../../../shared/services/accounts/ca-trans.service";
import { DataService } from "../../services/data.service"

export interface ItemsmodelCash {
  title: string;
  Items: any;
}
@Component({
  selector: "app-cashcollection-edit",
  templateUrl: "./cashcollection-edit.component.html",
  styleUrls: ["./cashcollection-edit.component.css"]
})
export class CashCollectionEditComponent extends DialogComponent<ItemsmodelCash, boolean>
  implements ItemsmodelCash, OnInit {
  title: string;
  Items: any;
  result: any = { result: false, RtnItem: {} };
  modelCash: any;
  loading: boolean = false;

  constructor(dialogService: DialogService, public datepipe: DatePipe, private cat: CaTransService, private ds: DataService) {
    super(dialogService);
  }

  ngOnInit() {
    this.modelCash = {}
    this.GetPOSCashCollectionById(this.Items)
  }

  GetPOSCashCollectionById(id: number) {
    this.loading = true;

    var data = {
      BranchId: this.ds.Settings.BranchId,
      RequestedList: {
        Start: 0,
        FiterText: "",
        Limit: this.ds.Settings.MaxLimit,
        ItemTypeId: this.ds.Settings.ItemTypeId,
        CAType: this.ds.Settings.CAType
      },
      RequstedListData: {
        FromDate: '',
        ToDate: '',
        FilterTypeId: 3,
        FilterType: 0
      },
      CCode: this.ds.Settings.CompanyId,
      CashAC: this.ds.Settings.CashAccount,
      BanckAC: this.ds.Settings.BankHead,
      CardAC: this.ds.Settings.CreditCardSalesAc,
      LocationId: this.ds.Settings.LocationId,
      Id: id
    }

    this.cat.GetPOSCashCollectionById(data).subscribe(res => {
      if (res.Success) {
        //console.log(res.data)
        this.modelCash = res.data;
        this.loading = false;
      } else {
        this.modelCash = [];
        this.loading = false;
      }
    });

  }

  GetCashCollectionDetails() {
    this.loading = true;
    var data = {
      Id: this.modelCash.ID,
      LocationId: this.modelCash.LocationID
    }
    this.cat.GetPOSCashCollectionDetails(data).subscribe(res => {
      if (res.Success) {
        this.modelCash.Cash_CollectionPostingDetails = res.data;
        this.loading = false;
      } else {
        this.modelCash.Cash_CollectionPostingDetails = [];
        this.loading = false;
      }
    });

  }

  ok() {
    this.UpdatePosCashCollection();
  }

  Validation(): boolean {
    if (this.modelCash.PaymentType == "Credit Card") {
      if (this.modelCash.CCardNo == "") {
        alert("Please enter Credit Card No.");
        return false;
      }
      this.modelCash.ChecqueNo = "";
      this.modelCash.ChequeDate = new Date();
    }
    if (this.modelCash.PaymentType == "Cheque") {
      if (this.modelCash.ChecqueNo == "") {
        alert("Please enter Checque No.");
        return false;
      }
      this.modelCash.CCardNo = "";
    }
    if (this.modelCash.PaymentType == "Cash") {
      this.modelCash.ChecqueNo = "";
      this.modelCash.CCardNo = "";
      this.modelCash.ChequeDate = new Date();
    }
    return true
  }

  UpdatePosCashCollection() {
    var r = confirm("Do you want to Update this record?");
    if ((r == true)) {
      if (this.Validation()) {

        this.loading = true;
        this.cat.UpdatePOSCashCollection(this.modelCash).subscribe(res => {
          if (res.Success) {
            alert("Updated Succesfully");
            this.loading = false;
            this.result.result = true;
            this.close();
          } else {
            this.result.result = false;
            this.loading = false;
            alert(res.error.UsrMsg);
          }
        });
      }
    }
  }

  delete() {
    var r = confirm("Do you want to Delete this record?");
    if ((r == true)) {
      var data: any = {
        Id: this.modelCash.ID,
        LocationId: this.modelCash.LocationID,
        CompanyId: this.modelCash.CompanyID
      }
      this.loading = true;
      this.cat.DeletePOSCashCollection(data).subscribe(res => {
        if (res.Success) {
          alert("Deleted Succesfully");
          this.loading = false;
          this.result.result = true;
          this.close();
        } else {
          this.result.result = false;
          this.loading = false;
          alert(res.error.UsrMsg);
        }
      });
    }
  }

  payment(v) {
    this.modelCash.PaymentType = v;
  }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/cashcollection-edit/cashcollection-edit.component.ts